import { IonIcon } from "@ionic/react";
import axios from "axios";
import { logoWhatsapp } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import ModalPacienteForm from "../../components/formComponents/ModalFormPaciente/ModalFormPaciente";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Link,
  Typography,
} from "@mui/joy";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";

const LoginIonic = () => {
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });

  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorFormulario, setMsjErrorFormulario] = useState("");
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useTituloPagina();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));
    setTituloPagina(localStorage.getItem("nombreClinica"));

    document.title = localStorage.getItem("tituloWeb");
    sessionStorage.removeItem("ppUL");
  }, []);

  const loginPaciente = async (usuario, password) => {
    try {
      const response = await axios.post(`${urlAxioPP}Usuarios/LoginPaciente`, {
        nombreUsuario: usuario,
        password: password,
      });
      return response.data.token;
    } catch (error) {
      setErrorPassword(true);
      setMsjErrorPassword("Documento o contraseña incorrecto");
      mostrarNotificacion(true, "Error: " + error.response.data, "rojo");
    }
  };

  const obtenerPaciente = async (token, documento) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(
        `${urlAxioPP}Pacientes?documento=${documento}`,
        config
      );
      const data = response.data[0];
      return {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.",
        "rojo"
      );
    }
  };

  const handleClickLogin = async () => {
    setCargando(true);
    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await loginPaciente(usuario.usuario, usuario.password);
      const paciente = await obtenerPaciente(token, usuario.usuario);
      if (paciente) {
        mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
        setUsuario(paciente);
        sessionStorage.setItem("ppUL", JSON.stringify(paciente));
        history.push("/portal/Inicio", { justLogin: true });
      }
    } else {
      if (usuario.usuario !== "") setErrorUsuario(true);
      if (usuario.password !== "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
    setCargando(false);
  };

  const handleClickSubmit = () => {
    setCargando(true);
    handleClickLogin();
    setCargando(false);
  };

  const handleChangeUsuario = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorUsuario(false);
    setUsuario({ usuario: filteredValue, password: usuario.password });
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorPassword(false);
    setUsuario({ usuario: usuario.usuario, password: filteredValue });
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "0810-555-2765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el número de telefono a su portapapeles",
      ""
    );
  };

  return (
    <div className="login">
      <Container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        style={{ height: "100vh", backgroundImage: "assets/fondo.png" }}
      >
        <Row item>
          <image
            href="assets/fondo.png"
            alt="Fondo"
            height={"100vh"}
            width={"100vw"}
          />
        </Row>

        {errorPassword && (
          <Row
            item
            style={{ width: "100%", maxWidth: "400px", marginBottom: "16px" }}
          >
            <Box
              sx={{
                backgroundColor: "#e53e3e",
                borderRadius: "6px",
                padding: "12px 16px",
                textAlign: "left",
                width: "100%",
                position: "relative",
              }}
            >
              <Typography
                level="body-sm"
                sx={{
                  color: "white",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "1.4",
                }}
              >
                ! {msjErrorPassword}
              </Typography>
            </Box>
          </Row>
        )}

        <Row item style={{ backgroundImage: "assets/assets/fondo.png" }}>
          <Card style={{ width: "350px" }}>
            <CardContent>
              <Row container spacing={2} rowGap={2}>
                <Column xs={12}>
                  <Box display="flex" justifyContent="center" mb={2}>
                    <img
                      alt="Logo clinica"
                      src="assets/logo.png"
                      height={"50%"}
                    />
                  </Box>
                  <Typography level="title-lg" align="center">
                    {"Portal del paciente".toUpperCase()}
                  </Typography>

                  <form
                    noValidate
                    autoComplete="off"
                    style={{ marginBottom: "7.5px" }}
                  >
                    <CustomInput
                      fullWidth
                      margin="normal"
                      value={usuario.usuario}
                      onChange={handleChangeUsuario}
                      error={errorUsuario}
                      startDecorator={
                        <Typography
                          variant="plain"
                          color="neutral"
                          sx={{ width: "100px" }}
                        >
                          Documento:
                        </Typography>
                      }
                    />
                    <hr />
                    <CustomInput
                      fullWidth
                      margin="normal"
                      startDecorator={
                        <Typography
                          variant="plain"
                          color="neutral"
                          sx={{ width: "100px" }}
                        >
                          Contraseña:
                        </Typography>
                      }
                      endDecorator={
                        <React.Fragment>
                          <Divider orientation="vertical" />
                          <Button
                            onClick={handleChangeVisibilityOfPassword}
                            type="button"
                            variant="plain"
                            color="neutral"
                          >
                            {blnVerPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </Button>
                        </React.Fragment>
                      }
                      type={blnVerPassword ? "text" : "password"}
                      value={usuario.password}
                      onChange={handleChangePassword}
                      error={errorPassword}
                      helperText={
                        "Si no cambio su contraseña, ingrese su numero de documento"
                      }
                      errorHelperText={msjErrorFormulario}
                    />
                    <CustomInput
                      fullWidth
                      variant="solid"
                      color="primary"
                      type="button"
                      onClick={handleClickSubmit}
                      disabled={cargando}
                      value={"Ingresar"}
                    />
                  </form>
                  <Typography level="body-xs" paddingInline={1}>
                    {
                      "Si es la primera vez que te vas a atender con nosotros, debes registrarte mediante nuestro WhatsApp."
                    }
                  </Typography>

                  <StyledButton
                    className="verde"
                    expand="block"
                    fill="clear"
                    onClick={handleClickCopiarTelefono}
                    href={
                      "https://api.whatsapp.com/send?phone=+5493513455853&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                    }
                    target="_blank"
                  >
                    <IonIcon icon={logoWhatsapp} />
                  </StyledButton>
                </Column>
              </Row>
            </CardContent>
          </Card>
        </Row>
        <Row item>
          <Link
            href="https://www.gacitua.com.ar/"
            rel="Proveedor del servicio noreferrer"
            target="_blank"
          >
            <Typography level="title-lg">
              <Typography color="neutral"> {"Powered by "}</Typography>
              <img
                src={"assets/logoGacitua.png"}
                alt="logo gacitua y asociados"
                width={17}
                height={17}
              />
              <Typography> {" Gacitua y asociados"}</Typography>
            </Typography>
          </Link>
        </Row>

        <CustomToast
          openToast={toast.open}
          onDidDismiss={() => mostrarNotificacion(false, "", "")}
          message={toast.mensaje}
          colorNotificacion={toast.tipo}
        />

        {cargando && <LoadingBackdrop visualizar={cargando} />}
      </Container>
    </div>
  );
};

export default LoginIonic;
